{
  "close": "Закрыть диалоговое окно"
}
